import { Box, Divider, Drawer, makeStyles } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useMemo } from "react";
import { analysisTabConfig, scoringTabConfig } from "src/config/constants/layout";
import { useUserContext } from "src/context/config/userContext";
import SidebarTab from "./SidebarTab";

const useStyle = makeStyles((theme) => ({
  drawer: {
    width: 220,
    padding: "5rem 1rem 0rem 1rem",
    [theme.breakpoints.down("sm")]: {
      width: 80,
    },
  },
}));

export default function Sidebar() {
  const cls = useStyle();
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const { role } = useUserContext();

  const realAnalysisTabConfig = useMemo(() => {
    if (role === "admin") return analysisTabConfig;
    else return analysisTabConfig.filter((element) => !element.isAdmin);
  });

  return (
    <Drawer anchor="left" classes={{ paper: cls.drawer }} variant="permanent">
      <Box height="100%">
        <SidebarTab tabType={scoringTabConfig} title={"Scoring"} open={matches} />
        <Divider light style={{ marginTop: "0.5rem", marginBottom: "1.5rem" }}></Divider>
        <SidebarTab tabType={realAnalysisTabConfig} title={"Analytics"} open={matches} />
      </Box>
    </Drawer>
  );
}
